import React from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { MdClose } from "react-icons/md";
import ImageZoom from "react-image-zooom";
// import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.min.css";

import "./questionImg.scss";

const QuestionImgModal = ({ questionImg, handleClose, show }) => {
  // const isFullscreen = useSelector((state) => state.fullscreen.isFullscreen);
  // const examStarted = useSelector((state) => state.timer.examStarted);
  // const dispatch = useDispatch();
  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(true);
  return (
    <>
      <Modal
        contentClassName="image-view-content-container"
        dialogClassName="image-view-dialog-container"
        show={show}
        // show={show}
        // onHide={handleClose}
        animation={true}
        backdrop="static"
        centered
      >
        <Modal.Body>
          <div className="d-flex flex-column align-items-center text-center">
            <div className="d-flex justify-content-end w-100 mb-4">
              <Button
                className="bg-white close-btn text-primary rounded-circle"
                onClick={handleClose}
              >
                <MdClose size={"2rem"} />
              </Button>
            </div>
            <div className="d-flex justify-content-end w-80">
              <div>
                <ImageZoom src={questionImg} alt="question image" />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default QuestionImgModal;
